
/**
 * Remove a column in a table
 *
 * @param {Draft.EditorState} editorState
 * @return {Draft.EditorState}
 */
function removeColumn(editorState) {
    // todo

    return editorState;
}

module.exports = removeColumn;
